import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { Button } from "./UI";
import { useModal } from "@/contexts/ModalContext";

interface BaseModalProps {
  title: ReactNode;
  content: ReactNode;
  confirmText?: ReactNode;
  cancelText?: ReactNode;
  showCancel?: boolean;
  onConfirm: () => void | Promise<void>;
  onCancel?: () => void;
}

export default function BaseModal({
  title,
  content,
  confirmText = "Confirm",
  cancelText = "Cancel",
  showCancel = true,
  onConfirm,
  onCancel
}: BaseModalProps) {
  const { closeModal } = useModal();

  const handleConfirm = async () => {
    await onConfirm();
    closeModal();
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      {typeof title === "string" ? (
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {title}
        </Typography>
      ) : (
        title
      )}

      {typeof content === "string" ? <Typography variant="body2">{content}</Typography> : content}

      <Box sx={{ display: "flex", justifyContent: "end", gap: "12px" }}>
        {showCancel && (
          <Button
            onClick={() => {
              closeModal();
              onCancel?.();
            }}
            variant="texted"
          >
            {cancelText}
          </Button>
        )}
        <Button variant="gradient" onClick={handleConfirm}>
          {confirmText}
        </Button>
      </Box>
    </Box>
  );
}
